import { getEnvVariable } from "../../modules/environmentalList"

const notadmindrawer = {
    "type": "drawer",
    "order": 2,
    "key": "drawer",
    "options": {
        "alignitem": "left",
        // "title": "notadmindrawer",
        "icon": "alarm",
        "open": true,
        "anchor": 'left',
        "admin": 'N',
        "items": [{
            "type": "tree",
            "title": "Dashboard",
            "materialicon": "dashboard",
            "key": "Dashboard",
            "items": [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },
                {
                    "type": "menu",
                    "title": "Invoice Dashboard",
                    "icon": "assessment",
                    "materialicon": "assessment",
                    "link": "/billingdashboard",
"reloadtab": true,
                    "key": "billingdashboard",
                    "style": {
                        'color': '#c158dc'
                    }
                },
                ]

        },
        {
            "type": "tree",
            "title": "My Portal",
            "materialicon": "corporate_fare",
            "key": "MyPortal",
            "items": [
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "search",
                    "materialicon": "search",
                    "link": "/search",
"reloadtab": true,
                    "key": "Search",
                    "style": {
                        'color': '#61A5DC'
                    }
                },
                {
                    "type": "recordmenu",
                    "title": "Records",
                    "materialicon": "source",
                    "key": "Records",
                    "items": [],
                    "lskey": "submodule"
                },
                {
                    "type": "menu",
                    "title": "Applicants",
                    "icon": "fa fa-building",
                    "link": "/Administration/companies",
                    "key": "companies",
                    "materialicon": "apartment",
                    "style": {
                        'color': '#ea156d'
                    }
                },
                {
                    "type": "menu",
                    "title": "External Contacts",
                    "key": "contacts",
                    "link": "/Administration/globalexternalcontacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#006064'
                    }
                },
                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },
                // {
                //     "type":"menu",
                //     "title": "Authorization",
                //     "key": "Authorization",
                //     "link": "/Administration/authorizations",
                //     "reloadtab": true,
                //     "icon": "fa fa-globe",
                //     "materialicon": "vpn_key",
                //     "style": {
                //         'color': '#c158dc'
                //     }
                // },


            ]

        },


        ]
    }
}

export default notadmindrawer